import { Button } from "@vds/buttons";
import { Input } from "@vds/inputs";
import { Line } from "@vds/lines";
import { DropdownSelect } from "@vds/selects";
import { Typography } from "@vds/typography";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import FloorPlan from "../../global/components/floorPlan/FloorPlan";
import {
  FloorPlanContainer,
  ReviewBlockRow,
  ReviewContainer,
  ReviewFovBlock,
  ReviewFovImage,
  ReviewFovName,
} from "../../global/components/OnboardingFormStyles/Styles";
import { BasicSnapshot } from "../../global/components/snapshots/BasicSnapshot";
import { snapshotImage, StreamType } from "../../hoc/snapshotImage";
import { CAMERA_ONBOARDING_TEST_IDS } from "./cameraOnboardingConstants";

const ReviewPage = (props) => {
  const {
    camDetails,
    companionSelected,
    floorSelected,
    areaSelected,
    subAreaSelected,
    cameraName,
    // snapshots,
    fovNames,
    cameraBlurValue,
    selectedCameraQR,
    camPosition,
    unpairedCamDetails,
  } = useSelector((state) => state.cameraonboardingReducer);
  const { cameraList } = useSelector((state) => state?.deviceReducer);
  const tagAllLists = useSelector((state) => state?.sitesReducer.tagIdList);
  const [cameraObj, setCameraObj] = useState([]);
  const numberOfFOVs = fovNames.length;
  const fieldOfViews =
    useSelector((state) => state.cameraonboardingReducer.fovNames) || [];
  const privacyObj = {
    OBJECT_BLUR: {
      children: "Anonymize people and vehicles by blurring their image",
      label: "Object blurring",
    },
    NO_BLUR: {
      children: "Do not anonymize people, vehicles, or faces",
      label: "No blurring",
    },
  };

  useEffect(() => {
    const tempCamObj = cameraList.filter(
      (item) => item.refid === selectedCameraQR
    );
    if (tempCamObj) {
      if (camPosition?.top) {
        tempCamObj[0].customdata.cameralocation.top = camPosition.top;
      }
      if (camPosition?.left) {
        tempCamObj[0].customdata.cameralocation.left = camPosition.left;
      }
      setCameraObj(tempCamObj);
    }
  }, [selectedCameraQR && cameraList && camPosition]);

  const BlockTitle = ({ title }) => {
    return <Typography fontWeight="600">{title}</Typography>;
  };

  const OpenTab = ({ index }) => {
    return (
      <Button
        size="small"
        use="secondary"
        onClick={() => handleEditClick(index)}
        data-testid={CAMERA_ONBOARDING_TEST_IDS.EDIT_REVIEW_TAB_BUTTON}
      >
        Edit
      </Button>
    );
  };

  const handleEditClick = (index) => {
    props?.handleTabChange(index);
  };

  return (
    <ReviewContainer>
      <ReviewBlockRow>
        <div>
          <BlockTitle title={"Companion & floor plan"} />
        </div>
        <div>
          <OpenTab index={0} />
        </div>
      </ReviewBlockRow>

      <DropdownSelect label="Companion" readOnly={true} width="328px">
        <option>{companionSelected.name}</option>
      </DropdownSelect>

      <DropdownSelect label="Floor plan" readOnly={true} width="328px">
        <option>{floorSelected.name}</option>
      </DropdownSelect>

      <Line type="secondary" />

      {/* --------------------------------------------------- */}
      <ReviewBlockRow>
        <div>
          <BlockTitle title={"Camera placement"} />
        </div>
        <div>
          <OpenTab index={1} />
        </div>
      </ReviewBlockRow>

      <FloorPlanContainer>
        {floorSelected && floorSelected?.imageurl ? (
          camDetails?.isPairing ? (
            <FloorPlan
              floorImage={floorSelected?.imageurl}
              FloorSize={[728, 367]}
              unPairedCam={unpairedCamDetails}
              isReview={true}
            />
          ) : (
            cameraObj &&
            cameraObj.length && (
              <FloorPlan
                widgetSize={"400px"}
                cameras={cameraObj}
                floorImage={floorSelected?.imageurl}
                isReview={true}
                isEditable={false}
                FloorSize={[728, 367]}
              />
            )
          )
        ) : (
          <span>No floor plan selected.</span>
        )}
      </FloorPlanContainer>

      <ReviewBlockRow>
        <DropdownSelect label="Area" readOnly={true} width="328px">
          <option>{tagAllLists.find(t => t?.id == areaSelected?.id)?.name}</option>
        </DropdownSelect>

        {/* <DropdownSelect label="Sub Area" readOnly={true} width="328px">
          <option>{subAreaSelected.name}</option>
        </DropdownSelect> */}
      </ReviewBlockRow>

      <Line type="secondary" />

      {/* --------------------------------------------------- */}
      <ReviewBlockRow>
        <div>
          <BlockTitle title={"Camera & area names"} />
        </div>
        <div>
          <OpenTab index={2} />
        </div>
      </ReviewBlockRow>

      <Input label="Camera name" width="328px" readOnly value={cameraName} />

      {fieldOfViews.length > 0 &&
        fieldOfViews.map((i, index) => {
          let SnapshotImg;
          if(props?.editFlow) {
            SnapshotImg = snapshotImage(
              BasicSnapshot,
              i.fovId,
              selectedCameraQR,
              StreamType.PAIRED_CAMERA,
              companionSelected?.id
            );
          } else {
            SnapshotImg = snapshotImage(
              BasicSnapshot,
              i.fovId,
              selectedCameraQR,
              StreamType.UNPAIRED_CAMERA,
              companionSelected?.id
            );
          }
         
          return (
            <ReviewFovBlock>
              <ReviewFovImage>
                <SnapshotImg />
              </ReviewFovImage>
              <ReviewFovName>
                <Input
                  readOnly={true}
                  label={`Stream ${index + 1}`}
                  defaultValue={i.fovName}
                />
              </ReviewFovName>
            </ReviewFovBlock>
          );
        })}

      <Line type="secondary" />

      {/* --------------------------------------------------- */}
      {/* Disabled Privacy Policy */}
      {/* <ReviewBlockRow>
        <div><BlockTitle title={'Privacy'} /></div>
        <div><OpenTab index={3} /></div>
      </ReviewBlockRow>

      {cameraBlurValue && privacyObj[cameraBlurValue] &&
        <ReviewBlockRow>
          <RadioButtonGroup>
            <RadioButton
              label={privacyObj[cameraBlurValue]?.label}
              children={privacyObj[cameraBlurValue]?.children}
              value={cameraBlurValue}
              readonly={true}
              selected={true}
            />
          </RadioButtonGroup>
        </ReviewBlockRow>
      } */}
    </ReviewContainer>
  );
};

export default ReviewPage;
